import { useCallback } from 'react';
import { Screen, StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import UploadDocuments from '../../components/UploadDocuments/UploadDocuments';

function UploadDocumentsScreen() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const onSubmit = useCallback(() => {
    navigation.popToTop();
    navigation.goBack();
  }, [navigation]);

  return (
    <Screen paddingBottom="safe-area-inset-bottom">
      <UploadDocuments onSubmit={onSubmit} />
    </Screen>
  );
}

export default UploadDocumentsScreen;
